<template>
  <!-- htmlファイル側の「<router-view>」内に表示する内容 -->
	
    <!--メインコンテンツ-->
  <div class="pc_only">
    <h2 class="kojin-title"><slot>タイトル</slot></h2>
  </div>
  
  <span class="sp_only">
      <span class="sp-title" style="color:#FFF;background: #FF8400;" v-on:click="Return_detail()">
        ← <slot>タイトル</slot>
        <input type="text" class="form-control" v-if="GlobalData.user_name" v-bind:value="GlobalData.user_name" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.$profile" value="未登録" readonly="readonly">
          <input type="text" class="form-control" v-else value="----------------------------------------------------------------------------------" readonly="readonly">
      </span>
    </span>
  <div class="p-2" style="margin-top:0;background-color:white">
        <!--メインコンテンツ-->
        <!-- パンくずリスト -->
        <nav class="pc_only" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>
            <li class="breadcrumb-item" v-on:click="ichiran" style="cursor:pointer">体験プログラム一覧</li>
            <li class="breadcrumb-item" v-on:click="Return_detail" style="cursor:pointer">体験プログラム詳細</li>
            <li class="breadcrumb-item active" aria-current="page"><slot>タイトル</slot></li>
            </ol>
      </nav>
      
        
        <div id="manual_area">

          <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />体験プログラムのマニュアル</span>
    <span class="pc_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>
    <span class="sp_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png" style="height:35px"  /></span>
        </div>

        <br clear="all">
        <template v-if="mode == 0">
          
          <div id="detail_button_area" class="pc_only">
              <button v-if="shubetsu==1" class="btn mx-aut" style="width: 200px; height: 50px;padding: 0;background-color: green;color:white;" v-on:click="Return_moushikomi">日時選択へ戻る</button>
              <button v-else-if="shubetsu==2" class="btn mx-aut" style="width: 200px; height: 50px;padding: 0;background-color: green;color:white;" v-on:click="Return_detail">プログラム詳細へ戻る</button>
          </div>

          <div style="width: 100%;max-width: 1300px;margin: auto;">
            
            <!--申込できない場合の文言-->
            <div class="other_area" v-if="moshikomi_fuka == false" style="text-align: center;">
              <b class="error">※このプログラムは満員です。</b>
            </div>

            <div class="vy-dotted" style="margin: 20px 0;" v-if="moshikomi_fuka == false"></div>
            <!--申込できない場合の文言ここまで-->

          <table class="vy-form-table" style="margin-top:0">
              <!-- 分類 -->
              <tr>
                <td colspan=2 style="text-align: left;">
                    {{ taiken_list.bunrui1 }}
                    <span v-if="taiken_list.bunrui2 != '' && taiken_list.bunrui2 != null">
                      <br>{{ taiken_list.bunrui2 }}
                    </span>
                  </td>
              </tr>
            
              <!--プログラムNo.:名称 -->
              <tr>
                <th colspan=2>
                  <span style="font-size:20px;color:#030ba0"><b>{{ taiken_list.taiken_no_text  }}：{{ taiken_list.name  }}</b></span>
                </th>
              </tr>

              <template v-if="shubetsu == 2">

                <tr><td colspan=2><div class="vy-dotted" ></div></td></tr>
                      <!-- 開催期間（制作・寄付のみ） -->
                      <tr>
                          <th>
                              <label for="">開催期間</label>
                          </th>
                          <td style="text-align: left">
                              {{DateSetting(taiken_list.kaisai_start)}}
                              <span v-if="taiken_list.kaisai_end && taiken_list.kaisai_end != taiken_list.kaisai_start"> ～ {{DateSetting(taiken_list.kaisai_end)}}</span>
                          </td>
                      </tr>

                <tr><td colspan=2><div class="vy-dotted" ></div></td></tr>
                      <!-- 制作定員（制作・寄付のみ） -->
                      <tr>
                          <th>
                              <label for="">定員</label>
                          </th>
                          <td style="text-align: left">
                              {{taiken_list.seisaku_teiin}} 人
                          </td>
                      </tr>


              </template>

            </table>

            <div class="other_area" v-if="shubetsu == 1">

              <!-- 活動1が存在する場合 -->
            <template v-if="sanka_list.length != 0">
                <table class="vy-form-table" style="margin-top:0">  
                  <tr><td colspan=2><div class="vy-dotted" ></div></td></tr>
                    <tr v-if="sub_list.length != 0">
                      <th colspan="2">
                          <label for="">【活動1】</label>
                      </th>
                    </tr>
                    <!--活動内容 -->
                    <tr>
                      <th>
                          <label for="">活動内容</label>
                      </th>
                      <td style="text-align: left;">
                        {{taiken_list.naiyou}}
                      </td>
                    </tr>
                    <!--申込条件 -->
                    <tr>
                      <th>
                          <label for="">申込条件</label>
                      </th>
                      <td style="text-align: left;">
                        <template  v-if="taiken_list.nittei_sentaku == 0">
                          {{taiken_list.nissu_mongon}}
                        </template>
                        <template v-else>
                          各日程ごとの全対象日に参加が必要
                        </template>
                      </td>
                    </tr>

                        <!-- その他（特記事項） -->
                      <template v-if="taiken_list.bikou!=null ">
                      <tr><td colspan=2><div class="vy-dotted" ></div></td></tr>
                        <tr>
                            <th >
                              <label for="">特記事項</label>
                            </th>
                            <td style="text-align: left;color:red;white-space: pre-wrap">
                              {{taiken_list.bikou}}
                            </td>
                        </tr>
                        
                      </template>
                  </table>
                  
                  <table id="moushikomi_table">
                      <tr style="text-align:center"><td>申込日</td><td>時間帯</td><td v-if="Shakyo_data.cancel_setting == 0">キャンセル待ち</td></tr>
                        
                      <tr style="text-align:center" v-for="(result,i) in sanka_list" v-bind:key="i">
                        <td>{{ DateSetting(result.kaisai_date) }} </td>
                        <td>{{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}</td>
                        <td v-if="Shakyo_data.cancel_setting == 0">
                          <span v-if="result.ninzu >= result.teiin" style="color:red">
                           有り（{{parseInt((result.ninzu - result.teiin)+1)}}番目）
                          </span>
                          <span v-else>
                            ー
                          </span>
                        </td>
                      </tr>
                </table>
            </template>
            

              <!-- 活動2以降が存在する場合 -->
              <template v-if="sub_list.length != 0">
                <template v-for="(sub,s) in sub_list" v-bind:key="s">
                <table class="vy-form-table" style="margin-top:0">  
                  <tr><td colspan=2><div class="vy-dotted" ></div></td></tr>
                    <tr>
                      <th colspan="2">
                          <label for="">【活動{{sub.sub_num+2}}】</label>
                      </th>
                    </tr>
                    <!--活動内容 -->
                    <tr>
                      <th>
                          <label for="">活動内容</label>
                      </th>
                      <td style="text-align: left;">
                        {{sub.naiyou}}
                      </td>
                    </tr>

                    <!--申込条件 -->
                    <tr>
                      <th>
                          <label for="">申込条件</label>
                      </th>
                      <td style="text-align: left;">
                        <template  v-if="sub.nittei_sentaku == 0">
                          {{sub.nissu_mongon}}
                        </template>
                        <template v-else>
                          各日程ごとの全対象日に参加が必要
                        </template>
                      </td>
                    </tr>
                        <!-- その他（特記事項） -->
                      <template v-if="sub.bikou!=null ">
                      <tr><td colspan=2><div class="vy-dotted" ></div></td></tr>
                        <tr>
                            <th >
                              <label for="">特記事項</label>
                            </th>
                            <td style="text-align: left;color:red;white-space: pre-wrap">
                              {{sub.bikou}}
                            </td>
                        </tr>
                        
                      </template>
                  </table>
                  
                  <table id="moushikomi_table">
                      <tr style="text-align:center"><td>申込日</td><td>時間帯</td><td v-if="Shakyo_data.cancel_setting == 0">キャンセル待ち</td></tr>
                         <tr r style="text-align:center" v-for="(result,i) in sanka_list_sub[s]" v-bind:key="i">
                        <td>{{ DateSetting(result.kaisai_date) }} </td>
                        <td>{{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}</td>
                        <td v-if="Shakyo_data.cancel_setting == 0">
                          <span v-if="result.ninzu >= result.teiin"  style="color:red">
                           有り（{{parseInt((result.ninzu - result.teiin)+1)}}番目）
                          </span>
                          <span v-else>
                            ー
                          </span>
                        </td>
                      </tr>
                  </table>
                </template>
              </template>
            </div>

            
            <template v-if="shubetsu == 2">

                <table class="vy-form-table" style="margin-top:0">  
                  <tr><td colspan=2><div class="vy-dotted" ></div></td></tr>
                  <!--  制作・寄付活動条件（制作・寄付のみ） -->
                  <tr>
                      <th>
                          <label for="">制作・寄付活動条件</label>
                      </th>
                      <td style="text-align: left">
                        {{taiken_list.seisaku_joken}}
                      </td>
                  </tr>

                  <tr><td colspan=2><div class="vy-dotted" ></div></td></tr>
                  <!-- 届け先（制作・寄付のみ） -->
                  <tr>
                      <th>
                          <label for="">届け先</label>
                      </th>
                      <td style="text-align: left">
                        {{taiken_list.todokesaki}}
                      </td>
                  </tr>
                </table>

            </template>

            <div class="other_area" v-if="jizen_set_flg == 3">
              <!-- 事前説明会が存在しない場合は非表示 -->
            </div>
            <div class="other_area" v-else-if="moshikomi_fuka == true && jizen_set_flg != 3">
              
              <div v-if="jizen_count == 0">選択できる事前説明会がありません。</div>

              <div v-else>
                <div class="vy-dotted" style="margin:10px 0"></div>
                <h6>
                  <b>
                    <span v-if="jizen_set_flg != 0" style="color: red;">
                      
                      {{jizen_message}}
                      <template v-if="nittei_reload != ''"><br>
                      {{nittei_reload}}
                      </template>
                    </span>
                    <span v-else>
                    
                      {{jizen_message}}
                      <template v-if="nittei_reload != ''"><br>
                      {{nittei_reload}}
                      </template>
                    </span>
                  </b>
                </h6>
                <div v-if="jizen_set_flg != 0">
                  <!-- 申込済の事前説明会 -->
                  <b>申込済の事前説明会</b>

                  <!-- PC -->
                  <table style="width: 100%;" class="pc_only">
  <!--
                    <tr><td>名称</td><td>開催日</td><td>時間帯</td><td>場所</td><td>住所</td></tr>
                      -->
                      <tr><td>名称</td><td>開催日時</td><td>受付〆切日</td><td>体験開始日</td><td>場所・住所</td><td>参加</td><td>特記事項</td></tr>
                      
                    <tr v-for="(result,i) in jizen_moushikomi_list" v-bind:key="i">

                      <td width="14%">{{ result.jizen_name }} </td>
                        <td width="10%">
                          
                              <template v-if="result.syurui == 3">
                                <template v-if="result.movie_start_date && result.kensyu_date">
                                  <!--両方とも入力-->
                                  {{ DateSetting(result.movie_start_date) }} ～ {{ DateSetting(result.kensyu_date) }}
                                </template>
                                <template v-else-if="!result.movie_start_date && result.kensyu_date">
                                  <!--至のみ入力-->
                                  {{ DateSetting(result.kensyu_date) }} まで
                                </template>
                                <template v-else-if="result.movie_start_date && !result.kensyu_date">
                                  <!--自のみ入力-->
                                  {{ DateSetting(result.movie_start_date) }} 以降
                                </template>
                                    <template v-else>
                                      ー
                                    </template> 
                              </template>
                                  <template v-else>
                                    <template v-if="result.kensyu_date">
                                      {{ DateSetting(result.kensyu_date) }}
                                      
                                    </template>
                                    <template v-else>
                                      ー
                                    </template> 
                                    <br>
                                    {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                  </template>
                        </td>
                        <td width="13%">{{ DateSetting(result.shimekiri_date) }} </td>
                        <td width="13%">
                          <template v-if="result.syurui != 3">
                            {{ DateSetting(result.taikenkaishi_date) }}
                          </template>
                          <template v-else>ー</template>
                        </td>
                        <td width="20%">{{ result.basyo }}
                          <br>
                          <span v-if="result.jusyo == '' || result.jusyo == null"></span>
                          <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                        </td>
                        <td width="10%">
                          
                          <span v-if="result.sanka_flg == 0">必須</span>
                          <span v-else>任意</span>
                        </td>
                    
                        <td width="15%">
                          <span v-if="result.bikou1 == '' || result.bikou1 == null">ー</span>
                          <span v-else style="color:red;white-space: pre-wrap">
                            {{ result.bikou1}} 
                          </span>
                        </td>
                    </tr>
                  </table>
                  
                  <!-- スマホ -->
                  <table style="width: 100%;" class="sp_only">
                    

                    <template v-for="(result,i) in jizen_moushikomi_list" v-bind:key="i">

                      <tr>
                        
                        <td width="35%">名称</td>
                        <td width="65%">{{ result.jizen_name }} </td>
                      
                      </tr>
                      <tr >
                        <td>
                          <template v-if="result.syurui == 3">視聴期間</template>
                          <template v-else>開催日時</template></td>
                        <td>
                              <template v-if="result.syurui == 3">
                                <template v-if="result.movie_start_date && result.kensyu_date">
                                  <!--両方とも入力-->
                                  {{ DateSetting(result.movie_start_date) }} ～ {{ DateSetting(result.kensyu_date) }}
                                </template>
                                <template v-else-if="!result.movie_start_date && result.kensyu_date">
                                  <!--至のみ入力-->
                                  {{ DateSetting(result.kensyu_date) }} まで
                                </template>
                                <template v-else-if="result.movie_start_date && !result.kensyu_date">
                                  <!--自のみ入力-->
                                  {{ DateSetting(result.movie_start_date) }} 以降
                                </template>
                                    <template v-else>
                                      ー
                                    </template> 
                              </template>
                                  <template v-else>
                                    <template v-if="result.kensyu_date">
                                      {{ DateSetting(result.kensyu_date) }}
                                      
                                    </template>
                                    <template v-else>
                                      ー
                                    </template> 
                                    {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                  </template>
                        </td>

                      </tr>
                      <tr >
                        <td>受付〆切日</td>
                        <td>
                          
                          <span v-if="result.shimekiri_date == '' || result.shimekiri_date == null|| result.shimekiri_date == 'None'">ー</span>
                          <span v-else> {{ DateSetting(result.shimekiri_date)  }}</span>
                        </td>

                      </tr>
                      <template v-if="result.syurui != 3">
                      <tr>
                        <td>体験開始日</td>
                        <td>
                          {{ DateSetting(result.taikenkaishi_date) }}
                        </td>
                        
                      </tr>
                      <tr>
                        <td>場所</td>
                        <td>
                          
                          <span v-if="result.basyo == '' || result.basyo == null|| result.basyo == 'None'">ー</span>
                          <span v-else> {{ result.basyo }}</span>
                        </td>
                        
                      </tr>
                      </template>
                      <template v-if="result.syurui == '1'">
                      <!-- 対面時のみ表示 -->
                        <tr>
                          <td>住所</td>
                          <td>
                            <span v-if="result.jusyo == '' || result.jusyo == null|| result.jusyo == 'None'">ー</span>
                            <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                          </td>
                        </tr>
                      </template>
                      <tr>
                          <td>特記事項</td>
                          <td>
                            <span v-if="result.bikou1 == '' || result.bikou1 == null|| result.bikou1 == 'None'">ー</span>
                            <span v-else style="color:red;">{{ result.bikou1 }}</span>
                        </td>
                      </tr>

                      <tr><td style="border:0"></td></tr>
                    </template>
                  </table>
                  
                </div>

                <!-- 対象となる事前説明会 -->
                <div v-if="jizen_set_flg != 2" style="padding-top: 10px;">
                  <b>対象となる事前説明会</b>

                  <!-- PC -->
                  <table style="width: 100%;" class="pc_only">
                    
                    <tr><td></td><td>名称</td><td>開催日時</td><td>受付〆切日</td><td>体験開始日</td><td>場所・住所</td><td>定員</td><td>参加</td><td>特記事項</td></tr>
                      
                    <tr v-for="(result,i) in disp_jizen_list" v-bind:key="i">
                      <td width="3%" style="text-align: center;width:auto;border-right: 0;border-top: 0;">
                        <div style="display:flex;align-items: center;justify-content: center;">
                          <!--【プログラムの種類が「施設・地域」の場合】
                              事前説明会の種類が1（対面）または2（オンライン）で、参加人数が定員未満の時 かつ 申込んだ日程（1日目）が説明会の体験開始日 かつ 申込日（画面を見ている当日）が受付〆切日よりも前
                              ※体験開始日と受付〆切日が空欄の場合はスルー
                              
                              【プログラムの種類が「制作・寄付」の場合】
                              事前説明会の種類が1（対面）または2（オンライン）で、参加人数が定員未満の時 かつ 申込日（画面を見ている当日）が受付〆切日よりも前 
                              ※受付〆切日が空欄の場合はスルー

                              【プログラムの種類が関係ない事前説明会】
                              事前説明会の種類が3（動画視聴）の時 
                              -->
                               <template v-if="(shubetsu == 1 &&( (result.syurui == 1 || result.syurui == 2) && (result.sanka_ninzu < result.teiin) 
                                                                 && (moushikomi_start >= TaikenkaishiSetting(result.taikenkaishi_date) || (result.taikenkaishi_date == null || result.taikenkaishi_date == ''))
                                                                 && (today <= TaikenkaishiSetting(result.shimekiri_date) || (result.shimekiri_date == null || result.shimekiri_date == ''))))
                                          || (shubetsu == 2 &&( (result.syurui == 1 || result.syurui == 2) && (result.sanka_ninzu < result.teiin) 
                                                                && (today <= TaikenkaishiSetting(result.shimekiri_date) || (result.shimekiri_date == null || result.shimekiri_date == '') )))
                                          || (result.syurui == 3 )">
                              <input type="radio" name="jizen" v-bind:id="['jizen_select' + result.jizen_id]" v-bind:value="[i]" />
                            </template>
                            
                          <template v-else>
                            ×
                          </template>
                        </div>
                      </td>
                      <td width="11%">{{ result.jizen_name }} </td>
                      <td width="10%">
                              <template v-if="result.syurui == 3">
                                <template v-if="result.movie_start_date && result.kensyu_date">
                                  <!--両方とも入力-->
                                  {{ DateSetting(result.movie_start_date) }} ～ {{ DateSetting(result.kensyu_date) }}
                                </template>
                                <template v-else-if="!result.movie_start_date && result.kensyu_date">
                                  <!--至のみ入力-->
                                  {{ DateSetting(result.kensyu_date) }} まで
                                </template>
                                <template v-else-if="result.movie_start_date && !result.kensyu_date">
                                  <!--自のみ入力-->
                                  {{ DateSetting(result.movie_start_date) }} 以降
                                </template>
                                    <template v-else>
                                      ー
                                    </template> 
                              </template>
                                  <template v-else>
                                    <template v-if="result.kensyu_date">
                                      {{ DateSetting(result.kensyu_date) }}
                                      
                                    </template>
                                    <template v-else>
                                      ー
                                    </template> 
                                    <br>
                                    {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                  </template>
                        </td>
                        <td width="13%">{{ DateSetting(result.shimekiri_date) }} </td>
                        <td width="13%">
                          <template v-if="result.syurui != 3">
                            {{ DateSetting(result.taikenkaishi_date) }}
                          </template>
                          <template v-else>ー</template>
                        </td>
                        <td width="20%">{{ result.basyo }}
                          <br>
                          <span v-if="result.jusyo == '' || result.jusyo == null"></span>
                          <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                        </td>
                        <td width="10%">
                          
                          <span v-if="result.syurui == 3">ー</span>
                          <span v-else-if="(result.teiin == '' || result.teiin == null)">ー</span>
                          <span v-else>
                          {{ result.sanka_ninzu }} 人 / {{ result.teiin }} 人
                          </span>
                        </td>
                        <td width="10%">
                          
                          <span v-if="result.sanka_flg == 0">必須</span>
                          <span v-else>任意</span>
                        </td>
                    
                      <td width="15%">
                        <span v-if="result.bikou1 == '' || result.bikou1 == null">ー</span>
                        <span v-else style="color:red;white-space: pre-wrap">
                          {{ result.bikou1}} 
                        </span>
                      </td>
                    </tr>
                  </table>

                  <!-- スマホ -->
                  
                  <table style="width: 100%;" class="sp_only">
                    <template v-for="(result,i) in disp_jizen_list" v-bind:key="i">

                      <tr>
                        
                          <!--【プログラムの種類が「施設・地域」の場合】
                              事前説明会の種類が1（対面）または2（オンライン）で、参加人数が定員未満の時 かつ 申込んだ日程（1日目）が説明会の体験開始日 かつ 申込日（画面を見ている当日）が受付〆切日よりも前
                              ※体験開始日と受付〆切日が空欄の場合はスルー
                              
                              【プログラムの種類が「制作・寄付」の場合】
                              事前説明会の種類が1（対面）または2（オンライン）で、参加人数が定員未満の時 かつ 申込日（画面を見ている当日）が受付〆切日よりも前 
                              ※受付〆切日が空欄の場合はスルー

                              【プログラムの種類が関係ない事前説明会】
                              事前説明会の種類が3（動画視聴）の時 
                              -->
                      <template v-if="result.syurui == '1'">
                        <td rowspan=9 width="10%" style="text-align: center;">
                           <template v-if="(shubetsu == 1 &&( (result.syurui == 1 || result.syurui == 2) && (result.sanka_ninzu < result.teiin) 
                                                                 && (moushikomi_start >= TaikenkaishiSetting(result.taikenkaishi_date) || (result.taikenkaishi_date == null || result.taikenkaishi_date == ''))
                                                                 && (today <= TaikenkaishiSetting(result.shimekiri_date) || (result.shimekiri_date == null || result.shimekiri_date == ''))))
                                          || (shubetsu == 2 &&( (result.syurui == 1 || result.syurui == 2) && (result.sanka_ninzu < result.teiin) 
                                                                && (today <= TaikenkaishiSetting(result.shimekiri_date) || (result.shimekiri_date == null || result.shimekiri_date == '') )))
                                          || (result.syurui == 3)">
                          <input type="radio" name="jizen" v-bind:id="['jizen_select' + result.jizen_id]" v-bind:value="[i]" />
                          </template>
                          <template v-else>
                            ×
                          </template>
                        </td>
                      </template>
                      <template v-else-if="result.syurui == '2'">
                        <td rowspan=8 width="10%" style="text-align: center;">
                          <template v-if="(shubetsu == 1 && ((result.syurui == 1 || result.syurui == 2) && result.sanka_ninzu < result.teiin && moushikomi_start >= TaikenkaishiSetting(result.taikenkaishi_date)  && today <= TaikenkaishiSetting(result.shimekiri_date) ))
                                          || (shubetsu == 2 && ((result.syurui == 1 || result.syurui == 2) && result.sanka_ninzu < result.teiin && today <= TaikenkaishiSetting(result.shimekiri_date)) )
                                          || (result.syurui == 3 )">
                          <input type="radio" name="jizen" v-bind:id="['jizen_select' + result.jizen_id]" v-bind:value="[i]" />
                          </template>
                          <template v-else>
                            ×
                          </template>
                        </td>
                      </template>
                      <template v-else-if="result.syurui == '3'">
                        <td rowspan=5 width="10%" style="text-align: center;">
                          <template v-if="(shubetsu == 1 && ((result.syurui == 1 || result.syurui == 2) && result.sanka_ninzu < result.teiin && moushikomi_start >= TaikenkaishiSetting(result.taikenkaishi_date)  && today <= TaikenkaishiSetting(result.shimekiri_date) ))
                                          || (shubetsu == 2 && ((result.syurui == 1 || result.syurui == 2) && result.sanka_ninzu < result.teiin && today <= TaikenkaishiSetting(result.shimekiri_date)) )
                                          || (result.syurui == 3 )">
                          <input type="radio" name="jizen" v-bind:id="['jizen_select' + result.jizen_id]" v-bind:value="[i]" />
                          </template>
                          <template v-else>
                            ×
                          </template>
                        </td>
                      </template>
                        <td width="30%">名称</td>
                        <td width="60%">{{ result.jizen_name }} </td>

                      </tr>
                      <tr >
                        <td>
                          <template v-if="result.syurui == 3">視聴期間</template>
                          <template v-else>開催日時</template>
                        </td>
                        <td>
                        
                              <template v-if="result.syurui == 3">
                                <template v-if="result.movie_start_date && result.kensyu_date">
                                  <!--両方とも入力-->
                                  {{ DateSetting(result.movie_start_date) }} ～ {{ DateSetting(result.kensyu_date) }}
                                </template>
                                <template v-else-if="!result.movie_start_date && result.kensyu_date">
                                  <!--至のみ入力-->
                                  {{ DateSetting(result.kensyu_date) }} まで
                                </template>
                                <template v-else-if="result.movie_start_date && !result.kensyu_date">
                                  <!--自のみ入力-->
                                  {{ DateSetting(result.movie_start_date) }} 以降
                                </template>
                                    <template v-else>
                                      ー
                                    </template> 
                              </template>
                                  <template v-else>
                                    <template v-if="result.kensyu_date">
                                      {{ DateSetting(result.kensyu_date) }}
                                      
                                    </template>
                                    <template v-else>
                                      ー
                                    </template> 
                                    {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                  </template>
                        </td>

                      </tr>
                      <tr >
                        <td>受付〆切日</td>
                        <td>
                          
                          <span v-if="result.shimekiri_date == '' || result.shimekiri_date == null|| result.shimekiri_date == 'None'">ー</span>
                          <span v-else> {{ DateSetting(result.shimekiri_date)  }}</span>
                        </td>

                      </tr>
                      
                    <template v-if="result.syurui != 3">
                      <tr>
                        <td>体験開始日</td>
                        <td>
                          {{ DateSetting(result.taikenkaishi_date) }}
                        </td>
                        
                      </tr>
                      <tr>
                        <td>場所</td>
                        <td>
                          
                          <span v-if="result.basyo == '' || result.basyo == null|| result.basyo == 'None'">ー</span>
                          <span v-else> {{ result.basyo }}</span>
                        </td>
                        
                      </tr>
                    </template>
                      <template v-if="result.syurui == '1'">
                      <!-- 対面時のみ表示 -->
                      <tr>
                        <td>住所</td>
                        <td>
                          <span v-if="result.jusyo == '' || result.jusyo == null|| result.jusyo == 'None'">ー</span>
                          <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                        </td>
                      </tr>
                      </template>
                      
                    <template v-if="result.syurui != 3">
                      <tr>
                        <td>定員</td>
                        <td>
                          <span v-if="result.teiin == '' || result.teiin == null">ー</span>
                          <span v-else>
                          {{ result.sanka_ninzu }} 人 / {{ result.teiin }} 人
                          </span>
                        </td>
                      </tr>
                      
                    </template>
                    
                      <tr>
                        <td>参加</td>
                        <td>
                          <span v-if="result.sanka_flg == 0">必須</span>
                          <span v-else>任意</span>
                        </td>
                      </tr>
                      <tr>
                          <td>特記事項</td>
                          <td>
                            <span v-if="result.bikou1 == '' || result.bikou1 == null|| result.bikou1 == 'None'">ー</span>
                            <span v-else style="color:red;white-space: pre-wrap">{{ result.bikou1 }}</span>
                        </td>
                      </tr>

                      <tr><td style="border:0"></td></tr>
                    </template>
                    
                  </table>
                </div>
              </div>
            
            </div>
            
              
            <div class="vy-dotted" style="margin: 20px 0;"  v-if="jigo_set_flg != 3"></div>
              <div v-if="jigo_set_flg == 3">
                <!-- 事後集会が存在しない場合は非表示 -->
              </div>
              <div class="other_area" v-else-if="jigo_set_flg != 3">

                <div>
                  <h6>
                    <b>
                      <span v-if="jigo_set_flg != 0" style="color: red;">
                        
                        {{jigo_message}}
                      </span>
                      <span v-else>
                      
                        {{jigo_message}}
                      </span>
                    </b>
                  </h6>
                  
                  <!-- 申込済の事後集会 -->
                  <div v-if="jigo_set_flg != 0">
                    <b>申込済の事後集会</b>
                    <!--PC-->
                    <table style="width: 100%;" class="pc_only">
                      <tr><td>集会名</td><td>集会日時</td><td>場所・住所</td><td>参加</td><td>特記事項</td></tr>
                        
                      <tr v-for="(result,i) in jigo_moushikomi_list" v-bind:key="i">
                        <td width="14%">{{ result.jigo_name }} </td>
                        <td width="10%">{{ DateSetting(result.kaisai_date) }} <br>
                          {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}</td>
                        <td width="50%">
                          {{ result.basyo }}
                          <br>
                          <span v-if="result.jusyo == '' || result.jusyo == null"></span>
                          <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                        </td>
                        
                        <td width="6%">
                          <span v-if="result.syomei_flg == 0">必須</span>
                          <span v-else >任意</span>
                        </td>
                        <td width="20%">
                          <span v-if="result.bikou1 == '' || result.bikou1 == null">ー</span>
                          <span v-else style="color:red;white-space: pre-wrap">
                            {{ result.bikou1 }} 
                          </span>
                        </td>
                      </tr>
                    </table>
                    <!-- スマホ -->
                    <table style="width: 100%;" class="sp_only">
                      <template v-for="(result,i) in jigo_moushikomi_list" v-bind:key="i">
                        <tr>
                          
                          <td width="35%">集会名</td>
                          <td width="65%">{{ result.jigo_name }} </td>
                        
                        </tr>
                        <tr >
                          <td>集会日時</td>
                          <td>
                            {{ DateSetting(result.kaisai_date) }} 
                            <span v-if="result.syurui != 3">
                            {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                            </span>
                            <span v-else>まで</span>
                          </td>

                        </tr>
                        <tr>
                          <td>場所</td>
                          <td>
                            
                            <span v-if="result.basyo == '' || result.basyo == null|| result.basyo == 'None'">ー</span>
                            <span v-else> {{ result.basyo }}</span>
                          </td>
                          
                        </tr>
                        <template v-if="result.syurui == '1'">
                        <!-- 対面時のみ表示 -->
                          <tr>
                            <td>住所</td>
                            <td>
                              <span v-if="result.jusyo == '' || result.jusyo == null|| result.jusyo == 'None'">ー</span>
                              <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                            </td>
                          </tr>
                        </template>

                        <tr>
                          <td>参加</td>
                          <td >
                            <span v-if="result.syomei_flg == 0">必須</span>
                            <span v-else >任意</span>
                          </td>
                        </tr>
                        <tr>
                            <td>特記事項</td>
                            <td>
                              <span v-if="result.bikou1 == '' || result.bikou1 == null|| result.bikou1 == 'None'">ー</span>
                              <span v-else style="color:red;white-space: pre-wrap">{{ result.bikou1 }}</span>
                          </td>
                        </tr>
                        <tr><td style="border:0"></td></tr>
                      </template>
                    </table>
                  </div>

                  <!-- 申込む必要がある場合のみ選択可能 -->
                  <div v-if="jigo_set_flg != 2" style="padding-top: 10px;">
                    <table style="width: 100%;" class="pc_only">
                      <tr><td></td><td>集会名</td><td>集会日時</td><td>場所・住所</td><td>定員</td><td>参加</td><td>特記事項</td></tr>
      
                      <tr v-for="(result,i) in disp_jigo_list" v-bind:key="i">
                        <td width="3%" style="text-align: center;">
                          
                          <!--参加数が定員未満の時 -->
                          <template v-if="result.sanka_ninzu < result.teiin">
                            <input type="radio" name="jigo" v-bind:id="['jigo_select' + result.jigo_id]" v-bind:value="[i]" />
                          </template>
                        </td>
                        <td width="11%">{{ result.jigo_name }} </td>
                        <td width="10%">{{ DateSetting(result.kaisai_date) }}<br>{{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                        </td>
                        <td width="40%">{{ result.basyo }}
                          <br>
                          <span v-if="result.jusyo == '' || result.jusyo == null"></span>
                          <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                        </td>
                        <td width="10%">
                          
                          <span v-if="result.teiin == '' || result.teiin == null">ー</span>
                          <span v-else>
                          {{ result.sanka_ninzu }} 人 / {{ result.teiin }} 人
                          </span>
                        </td>
                        
                          <td width="6%">
                            <span v-if="result.syomei_flg == 0">必須</span>
                            <span v-else >任意</span>
                          </td>
                        <td width="20%">
                                          
                                          <span v-if="result.bikou1 == '' || result.bikou1 == null">ー</span>
                                          <span v-else style="color:red;white-space: pre-wrap">
                                          {{ result.bikou1 }} 
                                          </span>
                                      </td>
                      </tr>
                    </table>

                    <!-- スマホ -->
                  <table style="width: 100%;" class="sp_only">
                    <template v-for="(result,i) in disp_jigo_list" v-bind:key="i">

                      <tr>
                        
                      <template v-if="result.syurui == '1'">
                        <td rowspan=7 width="10%" style="text-align: center;">
                        
                          <!--参加数が定員未満の時 -->
                          <template v-if="result.sanka_ninzu < result.teiin">
                            <input type="radio" name="jigo" v-bind:id="['jigo_select' + result.jigo_id]" v-bind:value="[i]" />
                          </template>
                          <template v-else>
                            ×
                          </template>
                        </td>
                      </template>
                      <template v-else>
                        
                        <td rowspan=6 width="10%" style="text-align: center;">
                        
                          <!--参加数が定員未満の時 -->
                          <template v-if="result.sanka_ninzu < result.teiin">
                            <input type="radio" name="jigo" v-bind:id="['jigo_select' + result.jigo_id]" v-bind:value="[i]" />
                          </template>
                          <template v-else>
                            ×
                          </template>
                        </td>
                      </template>
                        <td width="30%">集会名</td>
                        <td width="60%">{{ result.jigo_name }} </td>
                      </tr>
                      <tr >
                        <td>集会日時</td>
                        <td>
                          {{ DateSetting(result.kaisai_date) }}  {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                        </td>

                      </tr>
                      <tr>
                        <td>場所</td>
                        <td>
                          
                          <span v-if="result.basyo == '' || result.basyo == null|| result.basyo == 'None'">ー</span>
                          <span v-else> {{ result.basyo }}</span>
                        </td>
                        
                      </tr>
                      
                      <template v-if="result.syurui == '1'">
                      <!-- 対面時のみ表示 -->
                        <tr>
                          <td>住所</td>
                          <td>
                            <span v-if="result.jusyo == '' || result.jusyo == null|| result.jusyo == 'None'">ー</span>
                            <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                          </td>
                        </tr>
                      </template>
                      <tr>
                        <td>定員</td>
                        <td>
                          <span v-if="result.teiin == '' || result.teiin == null">ー</span>
                          <span v-else>
                          {{ result.sanka_ninzu }} 人 / {{ result.teiin }} 人
                          </span>
                        </td>
                      </tr>
                      
                        <tr>
                          <td>参加</td>
                          <td >
                            <span v-if="result.syomei_flg == 0">必須</span>
                            <span v-else >任意</span>
                          </td>
                        </tr>
                        <tr>
                            <td>特記事項</td>
                            <td>
                              <span v-if="result.bikou1 == '' || result.bikou1 == null|| result.bikou1 == 'None'">ー</span>
                              <span v-else style="color:red;white-space: pre-wrap">{{ result.bikou1 }}</span>
                          </td>
                        </tr>

                      <tr><td style="border:0"></td></tr>
                    </template>
                    
                  </table>
                  </div>
                </div>
              </div>
              
            
            <div class="vy-dotted" style="margin: 20px 0;" v-if="moshikomi_fuka == true && jizen_set_flg != 3"></div>
          </div>
          
          <div >
            <div  style="display: flex;justify-content: center;align-items: center;">
              <button v-if="shubetsu==1" class="btn mx-aut" style="width: 200px; height: 50px;padding: 0;background-color: green;color:white;" v-on:click="Return_moushikomi">日時選択へ戻る</button>
              <button v-else-if="shubetsu==2" class="btn mx-aut" style="width: 200px; height: 50px;padding: 0;background-color: green;color:white;" v-on:click="Return_detail">プログラム詳細へ戻る</button>
            
              <button class="btn btn-secondary" style="width:200px;height:50px;margin:0 10px;" v-if="(moshikomi_fuka == true && jizen_count != 0) || jizen_set_flg == 3" v-on:click="Set_jisseki">申込内容の確認</button>
            </div>
          </div>
        </template>

        <!-- 確認モード -->
        <template v-else-if="mode == 1">
          
          <h3 style="text-align:left">この内容で申し込みますか？</h3>
              <!-- 分類 -->
              <table class="vy-form-table" style="margin:0"> 
              <tr>
                <td colspan=2 style="text-align: left;">
                    {{ taiken_list.bunrui1 }}
                    <span v-if="taiken_list.bunrui2 != '' && taiken_list.bunrui2 != null">
                      <br>{{ taiken_list.bunrui2 }}
                    </span>
                  </td>
              </tr>
            
              <!--プログラムNo.:名称 -->
              <tr>
                <th colspan=2>
                  <span style="font-size:20px;color:#030ba0"><b>{{ taiken_list.taiken_no_text  }}：{{ taiken_list.name  }}</b></span>
                </th>
              </tr>
              </table>
              
            
            <template v-if="shubetsu == 2">

                <table class="vy-form-table" style="margin:0;">  
                  <tr><td colspan=2><div class="vy-dotted" ></div></td></tr>
                  <!--  制作・寄付活動条件（制作・寄付のみ） -->
                  <tr>
                      <th>
                          <label for="">制作・寄付活動条件</label>
                      </th>
                      <td style="text-align: left">
                        {{taiken_list.seisaku_joken}}
                      </td>
                  </tr>

                  <tr><td colspan=2><div class="vy-dotted" ></div></td></tr>
                  <!-- 届け先（制作・寄付のみ） -->
                  <tr>
                      <th>
                          <label for="">届け先</label>
                      </th>
                      <td style="text-align: left">
                        {{taiken_list.todokesaki}}
                      </td>
                  </tr>
                </table>

            </template>
            <!-- 活動1が存在する場合 -->
            <template v-if="sanka_list.length != 0">
                <table class="vy-form-table" style="margin:0">  
                  <tr><td colspan=2><div class="vy-dotted" ></div></td></tr>
                    <tr v-if="sub_list.length != 0">
                      <th colspan="2">
                          <label for="">【活動1】</label>
                      </th>
                    </tr>
                    <!--活動内容 -->
                    <tr>
                      <th>
                          <label for="">活動内容</label>
                      </th>
                      <td style="text-align: left;">
                        {{taiken_list.naiyou}}
                      </td>
                    </tr>
                    <!--申込条件 -->
                    <tr>
                      <th>
                          <label for="">申込条件</label>
                      </th>
                      <td style="text-align: left;">
                        <template  v-if="taiken_list.nittei_sentaku == 0">
                          {{taiken_list.nissu_mongon}}
                        </template>
                        <template v-else>
                          各日程ごとの全対象日に参加が必要
                        </template>
                      </td>
                    </tr>

                        <!-- その他（特記事項） -->
                      <template v-if="taiken_list.bikou!=null ">
                      <tr><td colspan=2><div class="vy-dotted" ></div></td></tr>
                        <tr>
                            <th >
                              <label for="">特記事項</label>
                            </th>
                            <td style="text-align: left;color:red;white-space: pre-wrap">
                              {{taiken_list.bikou}}
                            </td>
                        </tr>
                        
                      </template>
                </table>
                
            </template>
              <template v-if="shubetsu == 1">
                <template v-if="sanka_list.length != 0">
                  <h6 style="text-align:left;margin-top:10px">
                      <b>申込日時をご確認ください。</b>
                  </h6>
                  <table id="moushikomi_table">
                      <tr style="text-align:center"><td>申込日</td><td>時間帯</td><td v-if="Shakyo_data.cancel_setting == 0">キャンセル待ち</td></tr>
                        
                      <tr v-for="(result,i) in sanka_list" v-bind:key="i">
                        <td>{{ DateSetting(result.kaisai_date) }} </td>
                        <td>{{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}</td>
                        
                        <td v-if="Shakyo_data.cancel_setting == 0">
                          <span v-if="result.ninzu >= result.teiin"  style="color:red">
                           有り（{{parseInt((result.ninzu - result.teiin)+1)}}番目）
                          </span>
                          <span v-else>
                            ー
                          </span>
                        </td>
                      </tr>
                </table>
                </template>
                <template v-if="sub_list.length != 0">
                  <template v-for="(sub,s) in sub_list" v-bind:key="s">
                  <table class="vy-form-table" style="margin-top:0">  
                    <tr><td colspan=2><div class="vy-dotted" ></div></td></tr>
                      <tr>
                        <th colspan="2">
                            <label for="">【活動{{sub.sub_num+2}}】</label>
                        </th>
                      </tr>
                      <!--活動内容 -->
                      <tr>
                        <th>
                            <label for="">活動内容</label>
                        </th>
                        <td style="text-align: left;">
                          {{sub.naiyou}}
                        </td>
                      </tr>
                      
                    <!--申込条件 -->
                    <tr>
                      <th>
                          <label for="">申込条件</label>
                      </th>
                      <td style="text-align: left;">
                        <template  v-if="sub.nittei_sentaku == 0">
                          {{sub.nissu_mongon}}
                        </template>
                        <template v-else>
                          各日程ごとの全対象日に参加が必要
                        </template>
                      </td>
                    </tr>

                        <!-- その他（特記事項） -->
                      <template v-if="sub.bikou!=null ">
                      <tr><td colspan=2><div class="vy-dotted" ></div></td></tr>
                        <tr>
                            <th >
                              <label for="">特記事項</label>
                            </th>
                            <td style="text-align: left;color:red;white-space: pre-wrap">
                              {{sub.bikou}}
                            </td>
                        </tr>
                        
                      </template>
                  </table>

                  
                  <h6 style="text-align:left;margin-top:10px">
                      <b>申込日時をご確認ください。</b>
                  </h6>
                  <table id="moushikomi_table">
                       <tr style="text-align:center"><td>申込日</td><td>時間帯</td><td v-if="Shakyo_data.cancel_setting == 0">キャンセル待ち</td></tr>
                        
                      <tr v-for="(result,i) in sanka_list_sub[s]" v-bind:key="i">
                        <td>{{ DateSetting(result.kaisai_date) }} </td>
                        <td>{{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}</td>
                        <td v-if="Shakyo_data.cancel_setting == 0">
                          <span v-if="result.ninzu >= result.teiin" style="color:red">
                           有り（{{parseInt((result.ninzu - result.teiin)+1)}}番目）
                          </span>
                          <span v-else>
                            ー
                          </span>
                        </td>
                      </tr>
                  </table>

                  
                </template>
              </template>
          </template>
                  
          
                <div v-if="jizen_set_flg == 3">
<!--                事前説明会が存在しない場合は非表示 -->
                </div>
                <!-- 事前説明会申込済の場合 -->
                <div v-else-if="jizen_set_flg != 0" style="text-align:left">
                  
                  <div class="vy-dotted" style="margin: 20px 0;" ></div>
                  <b>申込済の事前説明会</b>

                  <!-- PC -->
                  <table style="width: 100%;" class="pc_only">
  <!--
                    <tr><td>名称</td><td>開催日</td><td>時間帯</td><td>場所</td><td>住所</td></tr>
                      -->
                      <tr><td>名称</td><td>開催日時</td><td>受付〆切日</td><td>体験開始日</td><td>場所・住所</td><td>参加</td><td>特記事項</td></tr>
                      
                    <tr v-for="(result,i) in jizen_moushikomi_list" v-bind:key="i">

                      <td width="14%">{{ result.jizen_name }} </td>
                        <td width="10%">
                          
                              <template v-if="result.syurui == 3">
                                <template v-if="result.movie_start_date && result.kensyu_date">
                                  <!--両方とも入力-->
                                  {{ DateSetting(result.movie_start_date) }} ～ {{ DateSetting(result.kensyu_date) }}
                                </template>
                                <template v-else-if="!result.movie_start_date && result.kensyu_date">
                                  <!--至のみ入力-->
                                  {{ DateSetting(result.kensyu_date) }} まで
                                </template>
                                <template v-else-if="result.movie_start_date && !result.kensyu_date">
                                  <!--自のみ入力-->
                                  {{ DateSetting(result.movie_start_date) }} 以降
                                </template>
                                    <template v-else>
                                      ー
                                    </template> 
                              </template>
                                  <template v-else>
                                    <template v-if="result.kensyu_date">
                                      {{ DateSetting(result.kensyu_date) }}
                                      
                                    </template>
                                    <template v-else>
                                      ー
                                    </template> 
                                    <br>
                                    {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                  </template>
                        </td>
                        <td width="13%">{{ DateSetting(result.shimekiri_date) }} </td>
                        <td width="13%">{{ DateSetting(result.taikenkaishi_date) }} </td>
                        <td width="20%">{{ result.basyo }}
                          <br>
                          <span v-if="result.jusyo == '' || result.jusyo == null"></span>
                          <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                        </td>
                        
                        <td width="10%">
                          
                          <span v-if="result.sanka_flg == 0">必須</span>
                          <span v-else>任意</span>
                        </td>
                    
                        <td width="15%">
                          <span v-if="result.bikou1 == '' || result.bikou1 == null">ー</span>
                          <span v-else style="color:red;white-space: pre-wrap">
                            {{ result.bikou1}} 
                          </span>
                        </td>
                    </tr>
                  </table>
                  
                  <!-- スマホ -->
                  <table style="width: 100%;" class="sp_only">
                    

                    <template v-for="(result,i) in jizen_moushikomi_list" v-bind:key="i">

                      <tr>
                        
                        <td width="35%">名称</td>
                        <td width="65%">{{ result.jizen_name }} </td>
                      
                      </tr>
                      <tr >
                        <td>
                          <template v-if="result.syurui == 3">視聴期間</template>
                          <template v-else>開催日時</template></td>
                        <td>
                              <template v-if="result.syurui == 3">
                                <template v-if="result.movie_start_date && result.kensyu_date">
                                  <!--両方とも入力-->
                                  {{ DateSetting(result.movie_start_date) }} ～ {{ DateSetting(result.kensyu_date) }}
                                </template>
                                <template v-else-if="!result.movie_start_date && result.kensyu_date">
                                  <!--至のみ入力-->
                                  {{ DateSetting(result.kensyu_date) }} まで
                                </template>
                                <template v-else-if="result.movie_start_date && !result.kensyu_date">
                                  <!--自のみ入力-->
                                  {{ DateSetting(result.movie_start_date) }} 以降
                                </template>
                                    <template v-else>
                                      ー
                                    </template> 
                              </template>
                                  <template v-else>
                                    <template v-if="result.kensyu_date">
                                      {{ DateSetting(result.kensyu_date) }}
                                      
                                    </template>
                                    <template v-else>
                                      ー
                                    </template> 
                                    {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                  </template>
                        </td>

                      </tr>
                      <tr >
                        <td>受付〆切日</td>
                        <td>
                          
                          <span v-if="result.shimekiri_date == '' || result.shimekiri_date == null|| result.shimekiri_date == 'None'">ー</span>
                          <span v-else> {{ DateSetting(result.shimekiri_date)  }}</span>
                        </td>

                      </tr>
                      <template v-if="result.syurui != 3">
                      <tr>
                        <td>体験開始日</td>
                        <td>
                          {{ DateSetting(result.taikenkaishi_date) }}
                        </td>
                        
                      </tr>
                      <tr>
                        <td>場所</td>
                        <td>
                          
                          <span v-if="result.basyo == '' || result.basyo == null|| result.basyo == 'None'">ー</span>
                          <span v-else> {{ result.basyo }}</span>
                        </td>
                        
                      </tr>
                      </template>
                      <template v-if="result.syurui == '1'">
                      <!-- 対面時のみ表示 -->
                        <tr>
                          <td>住所</td>
                          <td>
                            <span v-if="result.jusyo == '' || result.jusyo == null|| result.jusyo == 'None'">ー</span>
                            <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                          </td>
                        </tr>
                      </template>
                      <tr>
                          <td>特記事項</td>
                          <td>
                            <span v-if="result.bikou1 == '' || result.bikou1 == null|| result.bikou1 == 'None'">ー</span>
                            <span v-else style="color:red;white-space: pre-wrap">{{ result.bikou1 }}</span>
                        </td>
                      </tr>

                      <tr><td style="border:0"></td></tr>
                    </template>
                  </table>
                  
                </div>

          <template v-else-if="jisseki.jizen">
            
          <div class="vy-dotted" style="margin: 20px 0;" ></div>
            <label for="" style="float:left"><b>事前説明会</b></label>
            <template v-for="(result,i) in disp_jizen_list" v-bind:key="i">
              <template v-for="(jisseki,s) in jisseki.jizen" v-bind:key="s">
                <template v-if="result.jizen_id == jisseki.jizen_id">
                  <table style="width: 100%;text-align:left" class="pc_only">
                    
                    <tr><td>名称</td><td>開催日時</td><td>受付〆切日</td><td>体験開始日</td><td>場所・住所</td><td>定員</td><td>参加</td><td>特記事項</td></tr>
                      
                    <tr >
                      <td width="14%">{{ result.jizen_name }} </td>
                      <td width="10%">
                              <template v-if="result.syurui == 3">
                                <template v-if="result.movie_start_date && result.kensyu_date">
                                  <!--両方とも入力-->
                                  {{ DateSetting(result.movie_start_date) }} ～ {{ DateSetting(result.kensyu_date) }}
                                </template>
                                <template v-else-if="!result.movie_start_date && result.kensyu_date">
                                  <!--至のみ入力-->
                                  {{ DateSetting(result.kensyu_date) }} まで
                                </template>
                                <template v-else-if="result.movie_start_date && !result.kensyu_date">
                                  <!--自のみ入力-->
                                  {{ DateSetting(result.movie_start_date) }} 以降
                                </template>
                                    <template v-else>
                                      ー
                                    </template> 
                              </template>
                                  <template v-else>
                                    <template v-if="result.kensyu_date">
                                      {{ DateSetting(result.kensyu_date) }}
                                      
                                    </template>
                                    <template v-else>
                                      ー
                                    </template> 
                                    <br>
                                    {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                  </template>
                        </td>
                        <td width="13%">{{ DateSetting(result.shimekiri_date) }} </td>
                        <td width="13%">{{ DateSetting(result.taikenkaishi_date) }} </td>
                        <td width="20%">{{ result.basyo }}
                          <br>
                          <span v-if="result.jusyo == '' || result.jusyo == null"></span>
                          <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                        </td>
                        <td width="10%">
                          
                          <span v-if="result.syurui == 3">ー</span>
                          <span v-else-if="(result.teiin == '' || result.teiin == null)">ー</span>
                          <span v-else>
                          {{ result.sanka_ninzu }} 人 / {{ result.teiin }} 人
                          </span>
                        </td>
                        <td width="5%">
                          
                          <span v-if="result.sanka_flg == 0">必須</span>
                          <span v-else>任意</span>
                        </td>
                    
                      <td width="15%">
                        <span v-if="result.bikou1 == '' || result.bikou1 == null">ー</span>
                        <span v-else style="color:red;white-space: pre-wrap">
                          {{ result.bikou1}} 
                        </span>
                      </td>
                    </tr>
                  </table>

                  <!-- スマホ -->
                  
                  <table style="width: 100%;text-align:left" class="sp_only">

                      <tr>
                        <td width="30%">名称</td>
                        <td width="70%">{{ result.jizen_name }} </td>

                      </tr>
                      <tr >
                        <td>
                          <template v-if="result.syurui == 3">視聴期間</template>
                          <template v-else>開催日時</template>
                        </td>
                        <td>
                          
                              <template v-if="result.syurui == 3">
                                <template v-if="result.movie_start_date && result.kensyu_date">
                                  <!--両方とも入力-->
                                  {{ DateSetting(result.movie_start_date) }} ～ {{ DateSetting(result.kensyu_date) }}
                                </template>
                                <template v-else-if="!result.movie_start_date && result.kensyu_date">
                                  <!--至のみ入力-->
                                  {{ DateSetting(result.kensyu_date) }} まで
                                </template>
                                <template v-else-if="result.movie_start_date && !result.kensyu_date">
                                  <!--自のみ入力-->
                                  {{ DateSetting(result.movie_start_date) }} 以降
                                </template>
                                    <template v-else>
                                      ー
                                    </template> 
                              </template>
                                  <template v-else>
                                    <template v-if="result.kensyu_date">
                                      {{ DateSetting(result.kensyu_date) }}
                                      
                                    </template>
                                    <template v-else>
                                      ー
                                    </template> 
                                    {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                  </template>
                        </td>

                      </tr>
                      <tr >
                        <td>受付〆切日</td>
                        <td>
                          
                          <span v-if="result.shimekiri_date == '' || result.shimekiri_date == null|| result.shimekiri_date == 'None'">ー</span>
                          <span v-else> {{ DateSetting(result.shimekiri_date)  }}</span>
                        </td>

                      </tr>
                      
                    <template v-if="result.syurui != 3">
                      <tr>
                        <td>体験開始日</td>
                        <td>
                          {{ DateSetting(result.taikenkaishi_date) }}
                        </td>
                        
                      </tr>
                      <tr>
                        <td>場所</td>
                        <td>
                          
                          <span v-if="result.basyo == '' || result.basyo == null|| result.basyo == 'None'">ー</span>
                          <span v-else> {{ result.basyo }}</span>
                        </td>
                        
                      </tr>
                    </template>
                      <template v-if="result.syurui == '1'">
                      <!-- 対面時のみ表示 -->
                      <tr>
                        <td>住所</td>
                        <td>
                          <span v-if="result.jusyo == '' || result.jusyo == null|| result.jusyo == 'None'">ー</span>
                          <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                        </td>
                      </tr>
                      </template>
                      
                    <template v-if="result.syurui != 3">
                      <tr>
                        <td>定員</td>
                        <td>
                          <span v-if="result.teiin == '' || result.teiin == null">ー</span>
                          <span v-else>
                          {{ result.sanka_ninzu }} 人 / {{ result.teiin }} 人
                          </span>
                        </td>
                      </tr>
                    </template>
                    <tr>
                        <td>参加</td>
                        <td>
                          <span v-if="result.sanka_flg == 0">必須</span>
                          <span v-else>任意</span>
                        </td>
                    </tr>
                      <tr>
                          <td>特記事項</td>
                          <td>
                            <span v-if="result.bikou1 == '' || result.bikou1 == null|| result.bikou1 == 'None'">ー</span>
                            <span v-else style="color:red;white-space: pre-wrap">{{ result.bikou1 }}</span>
                        </td>
                      </tr>

                      <tr><td style="border:0"></td></tr>
                    
                  </table>
                </template>
              </template>
            </template>
            
          </template>
            <div v-if="jigo_set_flg == 3">
             <!-- 事後集会が存在しない場合は非表示 -->
            </div>
             <!-- 申込済の事後集会 -->
            <div v-else-if="jigo_set_flg != 0" style="text-align:left">
                 <div class="vy-dotted" style="margin: 20px 0;" ></div>
                    <b>申込済の事後集会</b>
                    <!--PC-->
                    <table style="width: 100%;" class="pc_only">
                      <tr><td>集会名</td><td>集会日時</td><td>場所・住所</td><td>参加</td><td>特記事項</td></tr>
                        
                      <tr v-for="(result,i) in jigo_moushikomi_list" v-bind:key="i">
                        <td width="14%">{{ result.jigo_name }} </td>
                        <td width="10%">{{ DateSetting(result.kaisai_date) }} <br>
                          {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}</td>
                        <td width="50%">
                          {{ result.basyo }}
                          <br>
                          <span v-if="result.jusyo == '' || result.jusyo == null"></span>
                          <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                        </td>
                        
                        <td width="6%">
                          <span v-if="result.syomei_flg == 0">必須</span>
                          <span v-else >任意</span>
                        </td>
                        <td width="20%">
                          <span v-if="result.bikou1 == '' || result.bikou1 == null">ー</span>
                          <span v-else style="color:red;white-space: pre-wrap">
                            {{ result.bikou1 }} 
                          </span>
                        </td>
                      </tr>
                    </table>
                    <!-- スマホ -->
                    <table style="width: 100%;" class="sp_only">
                      <template v-for="(result,i) in jigo_moushikomi_list" v-bind:key="i">
                        <tr>
                          
                          <td width="35%">集会名</td>
                          <td width="65%">{{ result.jigo_name }} </td>
                        
                        </tr>
                        <tr >
                          <td>集会日時</td>
                          <td>
                            {{ DateSetting(result.kaisai_date) }} 
                            <span v-if="result.syurui != 3">
                            {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                            </span>
                            <span v-else>まで</span>
                          </td>

                        </tr>
                        <tr>
                          <td>場所</td>
                          <td>
                            
                            <span v-if="result.basyo == '' || result.basyo == null|| result.basyo == 'None'">ー</span>
                            <span v-else> {{ result.basyo }}</span>
                          </td>
                          
                        </tr>
                        <template v-if="result.syurui == '1'">
                        <!-- 対面時のみ表示 -->
                          <tr>
                            <td>住所</td>
                            <td>
                              <span v-if="result.jusyo == '' || result.jusyo == null|| result.jusyo == 'None'">ー</span>
                              <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                            </td>
                          </tr>
                        </template>

                        <tr>
                          <td>参加</td>
                          <td >
                            <span v-if="result.syomei_flg == 0">必須</span>
                            <span v-else >任意</span>
                          </td>
                        </tr>
                        <tr>
                            <td>特記事項</td>
                            <td>
                              <span v-if="result.bikou1 == '' || result.bikou1 == null|| result.bikou1 == 'None'">ー</span>
                              <span v-else style="color:red;white-space: pre-wrap">{{ result.bikou1 }}</span>
                          </td>
                        </tr>
                        <tr><td style="border:0"></td></tr>
                      </template>
                    </table>
                  </div>

          <template v-else-if="jisseki.jigo">
                 <div class="vy-dotted" style="margin: 20px 0;" ></div>
            <label style="float:left"><b>事後集会</b></label>
            <template v-for="(result,i) in disp_jigo_list" v-bind:key="i">
              <template v-for="(jisseki,s) in jisseki.jigo" v-bind:key="s">
                <template v-if="result.jigo_id == jisseki.jigo_id">
                  <table style="width: 100%;text-align:left" class="pc_only">
                      <tr><td>集会名</td><td>集会日時</td><td>場所・住所</td><td>定員</td><td>参加</td><td>特記事項</td></tr>
      
                      <tr >
                        
                        <td width="14%">{{ result.jigo_name }} </td>
                        <td width="10%">{{ DateSetting(result.kaisai_date) }}<br>{{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                        </td>
                        <td width="40%">{{ result.basyo }}
                          <br>
                          <span v-if="result.jusyo == '' || result.jusyo == null"></span>
                          <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                        </td>
                        <td width="10%">
                          
                          <span v-if="result.teiin == '' || result.teiin == null">ー</span>
                          <span v-else>
                          {{ result.sanka_ninzu }} 人 / {{ result.teiin }} 人
                          </span>
                        </td>
                        <td width="6%">
                          
                          <span v-if="result.syomei_flg == 0">必須</span>
                          <span v-else>任意</span>
                        </td>
                        <td width="20%">
                                          
                          <span v-if="result.bikou1 == '' || result.bikou1 == null">ー</span>
                          <span v-else style="color:red;white-space: pre-wrap">
                            {{ result.bikou1 }} 
                          </span>
                        </td>
                      </tr>
                    </table>

                    <!-- スマホ -->
                    <table style="width: 100%;text-align:left" class="sp_only">

                      <tr>
                        
                        <td width="30%">集会名</td>
                        <td width="70%">{{ result.jigo_name }} </td>
                      </tr>
                      <tr >
                        <td>集会日時</td>
                        <td>
                          {{ DateSetting(result.kaisai_date) }}  {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                        </td>

                      </tr>
                      <tr>
                        <td>場所</td>
                        <td>
                          
                          <span v-if="result.basyo == '' || result.basyo == null|| result.basyo == 'None'">ー</span>
                          <span v-else> {{ result.basyo }}</span>
                        </td>
                        
                      </tr>
                      
                      <template v-if="result.syurui == '1'">
                      <!-- 対面時のみ表示 -->
                        <tr>
                          <td>住所</td>
                          <td>
                            <span v-if="result.jusyo == '' || result.jusyo == null|| result.jusyo == 'None'">ー</span>
                            <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                          </td>
                        </tr>
                      </template>
                      <tr>
                        <td>定員</td>
                        <td>
                          <span v-if="result.teiin == '' || result.teiin == null">ー</span>
                          <span v-else>
                          {{ result.sanka_ninzu }} 人 / {{ result.teiin }} 人
                          </span>
                        </td>
                      </tr>

                      <tr>
                        <td>参加</td>
                        <td >
                          <span v-if="result.syomei_flg == 0">必須</span>
                          <span v-else>任意</span>
                        </td>
                      </tr>
                        <tr>
                            <td>特記事項</td>
                            <td>
                              <span v-if="result.bikou1 == '' || result.bikou1 == null|| result.bikou1 == 'None'">ー</span>
                              <span v-else style="color:red;white-space: pre-wrap">{{ result.bikou1 }}</span>
                          </td>
                        </tr>

                      <tr><td style="border:0"></td></tr>
                    
                  </table>
                </template>
              </template>
            </template>
            
                 <div class="vy-dotted" style="margin: 20px 0;" ></div>
          </template>
          <table class="vy-form-table" border="1" rules="all" style="margin-top:10px;">
                <tr>
                  <td style="display: flex;align-items: center;justify-content: space-between;">
                    <b>連絡事項(社協へのメッセージ)</b>
                  </td>
                </tr>
                <tr>
                  <td >
                    <table style="width:100%" border="1" rules="all" >
                      <tr>
                        <td >
                        <b>メッセージタイトル(連絡事項の項目)</b><br>
                          <input type="text" style="width:100%" v-model="message_title" />
                        </td>
                      </tr>
                      
                      <tr>
                        <td >
                        <b>内容</b><br>
                        <textarea style="width:100%" rows=3 v-model="message_honbun" ></textarea>

                        </td>
                      </tr>

                    </table>
                  </td>
                </tr>

              </table>
          
          <div>
            <div v-if="shubetsu == 2" style="display: flex;margin: 10px;align-items: center;justify-content: center;" >
              <input type="checkbox" class="form-check-input" v-model="naiyou_doui" style="width:25px;height:25px;margin:0 10px 0 0;border:1px solid #000">活動内容に同意する
            </div>
            <div style="display: flex;justify-content: center;align-items: center;">
              <button class="btn mx-aut" style="width: 200px; height: 50px;padding: 0;background-color: green;color:white;" v-on:click="Return_check">戻る</button>
            
              <button class="btn btn-secondary" style="width:200px;height:50px;margin:0 10px;" v-if="(moshikomi_fuka == true && jizen_count != 0) || jizen_set_flg == 3" v-on:click="Send_jisseki">この内容で申込む</button>
            </div>
          </div>
        </template>
      </div>

      <!-- スマホ専用ボタン（フローティングメニューの上に配置） -->
      <!--
      <div class="vy-responsive-menu-container floating_over" 
          style="
          margin-bottom: 50px;
          padding: 10px 0;
          background: rgba(0, 0, 0, .5);
          border: 0px;
          justify-content: space-evenly;">

          <div style="width:100%;display: flex;justify-content: space-around;">
            
            <template v-if="mode == 0">
                <button v-if="shubetsu==1" class="btn mx-aut" style="width: 45%; height: 50px;padding: 0;background-color: green;color:white;" v-on:click="Return_moushikomi">日時選択へ戻る</button>
                <button v-else-if="shubetsu==2" class="btn mx-aut" style="width: 45%; height: 50px;padding: 0;background-color: green;color:white;" v-on:click="Return_detail">詳細へ戻る</button>
                <button class="btn btn-secondary" style="width: 45%;height:50px;padding-top: 5px;background-color:#FF8400" v-if="(moshikomi_fuka == true && jizen_count != 0) || jizen_set_flg == 3" v-on:click="Set_jisseki">申込内容の確認</button>

            </template>

            <template v-else-if="mode == 1">
              
              <div v-if="shubetsu == 2" style="width: 100%;display: flex;justify-content: space-around;flex-direction: column;">
                <div style="margin:0 0 10px 0">
                  <input type="checkbox" class="form-check-input" v-model="naiyou_doui" style="width:25px;height:25px;margin:0 10px 0 0;border:1px solid #000">活動内容に同意する
                </div>
                <div style="width: 100%;display: flex;justify-content: space-around;">
                  <button class="btn mx-aut" style="width: 45%; height: 50px;padding: 0;background-color: green;color:white;" v-on:click="Return_check">戻る</button>
                  <button class="btn btn-secondary" style="width: 45%;height:50px;padding-top: 5px;background-color:#FF8400" v-on:click="Send_jisseki">申込む</button>
                </div>
              </div>
              <template v-else>
                <button class="btn mx-aut" style="width: 45%; height: 50px;padding: 0;background-color: green;color:white;" v-on:click="Return_check">戻る</button>
                <button class="btn btn-secondary" style="width: 45%;height:50px;padding-top: 5px;background-color:#FF8400" v-on:click="Send_jisseki">申込む</button>
              </template>
            </template>
          </div>
      </div>

      -->

      <!--メッセージを表示するモーダルウィンドウ-->
      <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                @close_message="Close_message"
                @ok_message="OK_message"/>
</template>


<script setup>

/* eslint-disable */
// 子コンポーネントの指定

/* メッセージを表示するモーダルウィンドウ */
import MessageModal from '../common/MessageModal.vue'  
import axios from 'axios'
import { ref,computed,watchEffect } from 'vue'
import { useRouter,useRoute } from 'vue-router'
import { GlobalData, getUser_email,DateSetting,TimeSetting,DateTimeSetting } from '../js/userdata.js'

let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

let URL = GlobalData.$API_URL
const router = useRouter();
const route = useRoute();

const cityname = route.params.shakyo

let Shakyo_data = {}
let title = "申込内容確認"
let youbi_list = [ "日", "月", "火", "水", "木", "金", "土" ]
  // プログラムの種別配列
  const shubetsu_list = ["（未設定）","施設・地域活動","制作・寄付活動"]

// メッセージ送信
let message_title = ref("")
let message_honbun = ref("")

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント

let mode = ref(0) // 0：事前・事後・メッセージ、1：確認

const emit = defineEmits(['call'])

// 親コンポーネント（User.vue）から送られてきた値
// sanka     ：参加する活動1の予定の日付（制作・寄付の場合はnull）
// sanka_sub ：参加する活動２以降予定の日付（制作・寄付の場合はnull。施設・地域の場合でもnullの時はある）
// taiken    ：参加する予定の体験プログラムの活動１
// sub       ：参加する予定の体験プログラムの活動２以降（施設・地域のみ。無い場合もある）
// jizen     ：このプログラムに必要な事前説明会のリスト
// jigo      ：このプログラムに必要な事後集会のリスト
// user_id   ：申込むユーザーのID
// set_jizen ：すでに申込まれている事前説明会の実績データ
// set_jigo  ：すでに申込まれている事後集会の実績データ
// moushikomi：申込可不可のフラグ
// cityname  ：所属社協
const props = defineProps(["param"])

let sanka_list = props.param.sanka

console.log(sanka_list)
let cancel_wait_message = ref("")
let cancel_wait_flg = 0 // キャンセル待ちフラグ（待ち機能利用時、1つでもあったら立てる）

let sub_cancel_wait_message = ref([])
let sanka_list_sub =  []

  if(props.param.sanka_sub){
    console.log(props.param.sanka_sub)
    sanka_list_sub = props.param.sanka_sub
  }


let taiken_list = props.param.taiken

let sub_list = []
if(props.param.sub){
  sub_list = props.param.sub
}
let jizen_list = {}
if(props.param.jizen){
  jizen_list = props.param.jizen
}
let jigo_list = {}
if(props.param.jigo){
  jigo_list = props.param.jigo
}

let taiken_id = taiken_list["taiken_id"]
let shubetsu = taiken_list["shubetsu"] // 1：施設・地域、2：制作・寄付

  // 1：施設・地域・・・申込む予定の1日目（体験開始日・申込〆切日と比較）
  // 2：制作・寄付・・・本日（事前説明会の受付〆切日と比較）
  let moushikomi_start = null // 最初はnull
  if(shubetsu == 1){
    // まず活動1が存在する場合はその1日目の開催日を格納
    if(sanka_list.length != 0){
      moushikomi_start = new Date(sanka_list[0]["kaisai_date"])
    }else{
      // 存在しない場合は活動2以降の1日目
      moushikomi_start = new Date(sanka_list_sub[0][0]["kaisai_date"])

    }
    if(sanka_list_sub.length != 0){
      for(let s = 0;s<sanka_list_sub.length;s++){
        // 活動2は複数あるので、その分だけ1日目の開催日をチェック
        let check_date = new Date(sanka_list_sub[s][0]["kaisai_date"])
        console.log(check_date+"/"+moushikomi_start)
        console.log(moushikomi_start >= check_date)
        // すでに格納された申込予定の1日目より、比較した開催日が前ならば、その開催日を申込予定1日目にする
        if(moushikomi_start == null || moushikomi_start >= check_date){
          moushikomi_start = check_date
          console.log(moushikomi_start)
        }

      }

    }
  }
  // moushikomi_startがnull（初期値のまま）なら今日の日付、それ以外は代入した日付を入れる
  if(moushikomi_start == null){
    moushikomi_start = new Date()
  }else{
    moushikomi_start = new Date(moushikomi_start.getFullYear(),moushikomi_start.getMonth(),moushikomi_start.getDate(),23,59,59)
  }
  console.log(moushikomi_start)

let user_id = props.param.user_id

// 申込む実績データ
let jisseki = {}

// 選択できる事前説明会を格納する配列（申込日等から一部除外する）
let disp_jizen_list = ref([])

// 選択できる事前説明会の数
let jizen_count = ref(0)

// 申込まれた事前説明会のID
let set_jizen_id = 0

// 以前申込んでいた事前説明会をキャンセルすべきかのフラグ（施設・地域のみ）
// 0：事前説明会を何も申込んでいない
// 1：申込んだ事前説明会ではこの体験プログラムに申込めないので、改めて申込む
// 2：申込んだ事前説明会でOKなので、改めて事前説明会を申込む必要はない
// 3：事前説明会が必要のない体験プログラム
let jizen_set_flg = ref(0)
// 以前申込んでいた事前説明会に関するメッセージ（事前説明会の再申込が必要かどうか、キャンセルする必要がないかどうか等）
let jizen_message = ref("参加する事前説明会を選択してください。")
let nittei_reload = ref("")
let jizen_moushikomi_list = ref([])
// キャンセルする事前説明会
let cancel_jizen_id = 0

// すでに申込まれている事前説明会（配列）
let set_jizen = {}
if(props.param.set_jizen != undefined){
  set_jizen = props.param.set_jizen 
}

// 申込まれた事後集会のID
let set_jigo_id = 0

// 選択できる事後集会を格納する配列（申込日等から一部除外する）
let disp_jigo_list = ref([])

// 選択できる事後集会の数
let jigo_count = ref(0)

// 以前申込んでいた事後集会をキャンセルすべきかのフラグ
// 0：事後集会を何も申込んでいない
// 1：申込んだ事後集会ではこの体験プログラムに申込めないので、改めて申込む
// 2：申込んだ事後集会でOKなので、改めて事後集会を申込む必要はない
// 3：事後集会が必要のない体験プログラム
let jigo_set_flg = ref(0)

// 以前申込んでいた事後集会に関するメッセージ（事後集会の再申込が必要かどうか、キャンセルする必要がないかどうか等）
let jigo_message = ref("参加する事後集会を選択してください。")
let jigo_moushikomi_list = ref([])

// キャンセルする事後集会
let cancel_jigo_id = 0

// すでに申込まれている事後集会（配列）
let set_jigo = {}
if(props.param.set_jigo != undefined){
  set_jigo = props.param.set_jigo
}

// 今日の日付（〆切日と比較用）
const today = new Date()

// 満員だった時、申込めないようにする（制作・寄付のみ）
let moshikomi_fuka = ref(true)
if(props.param.moshikomi != undefined){
  moshikomi_fuka.value = props.param.moshikomi
}

// 活動内容に同意したかどうか（制作・寄付の時のみ利用）
let naiyou_doui = ref(true)
if(shubetsu == 2){// 制作・寄付の時は初期値をfalseにする
  naiyou_doui.value = false
}


/* 親コンポーネントに関わる関数 */
// 申込確認コンポーネントから体験プログラム詳細コンポーネントの詳細タブに戻す
let Return_detail = function(){
    emit('call',{cmd:'detail',type:"tab_detail"});
}

// 申込確認コンポーネントから体験プログラム詳細のコンポーネントの日付一覧タブに戻す
let Return_moushikomi = function(){
    emit('call',{cmd:'detail',type:"tab_list"});
}


/* その他関数の記述 */

// 申込日や申込当日、定員等で一部の事前説明会を除外し、表示する事前説明会だけを残す
let Set_jizen_list = function(){



  // 一時的に格納する事前説明会のリスト
  let temp_jizen_list = []

  // 選択できる事前説明会カウントを初期化
  jizen_count.value = 0
  console.log(Shakyo_data.flow)

  // 体験申込の流れがケース2（プログラムと説明会を同時に申し込む場合）
  if(Shakyo_data.flow == 2){
    // 事前説明会No.を格納する配列
    let taiken_jizen_no = [];
    
    // 体験プログラムの割付事前説明会No.を取り出す
    if(taiken_list.jizenkensyu_no != "" && taiken_list.jizenkensyu_no != null && taiken_list.jizenkensyu_no != "None" ){
      taiken_jizen_no = taiken_list.jizenkensyu_no.split(',')
    }

    console.log(jizen_list)
    console.log(taiken_jizen_no)

    for(let i = 0;i < jizen_list.length;i++){

      // ver2以降
      // プログラムに紐づいたNo.があれば格納
      let ok_flg = 0
      for(let t = 0;t<taiken_jizen_no.length;t++){
        if(taiken_jizen_no[t] == jizen_list[i]["jizen_no"]){
          ok_flg = 1
        }
      }
    console.log(ok_flg)
      
      for(let j = 0;j<set_jizen.length;j++){
        let jisseki_kobetsu = set_jizen[j]
        // 実績にプログラム区分２（事前説明会）がある場合
        if(jisseki_kobetsu["program_kbn"] == 2){
          if(jisseki_kobetsu["jokyo"] == '2'){
            if(all_jizen_list[i]["jizen_id"] == jisseki_kobetsu["program_id"]){
                ok_flg = 0
            }
          }
        }
      }
    console.log(ok_flg)
      if(ok_flg == 0){
        continue
      }
      
      // 上記3パターンに合致しない場合は表示用事前説明会リストへ格納
      temp_jizen_list[jizen_count.value] = jizen_list[i]
      jizen_count.value++

    }

    // 格納する
    disp_jizen_list.value = temp_jizen_list

    if(taiken_jizen_no != [] && taiken_jizen_no != null && taiken_jizen_no != '' && jizen_list.length != 0){
      // すでに申込まれている事前説明会がある場合
      if(set_jizen.length != 0){

        // すでに申込まれている事前説明会が、選択できる事前説明会と一緒かどうか確認する
        for(let s = 0;s<set_jizen.length;s++){
          
          // キャンセル済みの事前説明会は除く
          if(set_jizen[s].jokyo != 9 ){
            // 申込済みの事前説明会が「特殊（対面・オンライン）」の場合は問答無用で参加可能とする
            if (set_jizen[s].syurui == 4 || set_jizen[s].syurui == 5 ){
              jizen_set_flg.value = 2
              jizen_message.value = "事前説明会はすでに参加済です。"
              jizen_moushikomi_list.value[0] = set_jizen[s]
              break;
            }
            for(let i = 0;i < taiken_jizen_no.length;i++){
              // No.で比較し、存在していた場合
              if(set_jizen[s].jizen_no == taiken_jizen_no[i]){

                let taikenkaishi_date = new Date(set_jizen[s]["taikenkaishi_date"])
                taikenkaishi_date = new Date(taikenkaishi_date.getFullYear(),taikenkaishi_date.getMonth(),taikenkaishi_date.getDate(),23,59,59)
        
                // 参加済の事前説明会があればOK
                if(set_jizen[s].jokyo > 1){
                    jizen_set_flg.value = 2
                    jizen_message.value = "事前説明会はすでに参加済です。"
                    jizen_count.value++
                }else 
                // 体験プログラムの申込日（初日）が、すでに申込んでいる事前説明会の体験開始日よりも前になる場合(種別が施設・地域活動の場合のみ)
                if(taikenkaishi_date > moushikomi_start && shubetsu == 1 && set_jizen[s].syurui != 3){
                  // キャンセルする旨を表示する
                  jizen_set_flg.value = 1
                  jizen_message.value = "申込済の事前説明会ではこの体験プログラムの申込日に参加できません。事前説明会を変更してください。"
                  nittei_reload.value = "※事前説明会が変更できない場合は、前の画面に戻って体験プログラムの申込日を変更してください。"
                  cancel_jizen_id = set_jizen[s].jizen_id

                }else{

                    // 体験プログラムの申込日（初日）が、すでに申込んでいる事前説明会の体験開始日よりも後になる場合
                    // 事前説明会の状況に応じてメッセージを変更する
                    jizen_set_flg.value = 2
                    if(set_jizen[s].jokyo == 1){
                      jizen_message.value = "事前説明会はすでに申込済です。"
                    }
                    set_jizen_id = set_jizen[s].jizen_id
                }

                jizen_moushikomi_list.value[0] = set_jizen[s]

              }
            }
          }
        }
      }
    }else{
        // この体験プログラムに事前説明会はありません。
        jizen_set_flg.value = 3
        jizen_message.value = "この体験プログラムに事前説明会はありません。"
    }
  }else{
      // 体験申込の流れがケース1（説明会を先に申し込む場合）
      // 代行の場合は説明会申込の必要なし
      jizen_set_flg.value = 3

  }
}


// 表示する事後集会をセットする
let Set_jigo_list = function(){


  // 一時的に格納する事後集会のリスト
  let temp_jigo_list = []

  // 選択できる事後集会カウントを初期化
  jigo_count.value = 0

  // 事後集会No.を格納する配列
  let taiken_jigo_no = [];


  // 体験プログラムの割付事後集会No.を取り出す
  if(taiken_list.jigosyukai_no != "" && taiken_list.jigosyukai_no != null){
    taiken_jigo_no = taiken_list.jigosyukai_no.split(',')
  }

  console.log(taiken_jigo_no)

  for(let i = 0;i < jigo_list.length;i++){

    // プログラムに紐づいたNo.があれば格納
    let ok_flg = 0
    for(let t = 0;t<taiken_jigo_no.length;t++){
      if(taiken_jigo_no[t] == jigo_list[i]["jigo_no"]){
        ok_flg = 1
      }
    }
    if(ok_flg == 0){
      continue
    }

    // 上記3パターンに合致しない場合は表示用事後集会リストへ格納
    temp_jigo_list[jigo_count.value] = jigo_list[i]
    jigo_count.value++

  }

  // 格納する
  disp_jigo_list.value = temp_jigo_list


  if(taiken_jigo_no.length != 0 && jigo_list.length != 0){
    // すでに申込まれている事後集会がある場合
    if(set_jizen.length != 0){
      
      // すでに申込まれている事後集会が、選択できる事後集会と一緒かどうか確認する
      for(let s = 0;s<set_jigo.length;s++){
        
        // キャンセル済みの事後集会は除く
        if(set_jigo[s].jokyo != 9 ){

          for(let i = 0;i < taiken_jigo_no.length;i++){
            // No.で比較し、存在していた場合
            if(set_jigo[s].jigo_no == taiken_jigo_no[i]){

                // 事後集会の状況に応じてメッセージを変更する
                jigo_set_flg.value = 2
                if(set_jigo[s].jokyo == 1){
                  jigo_message.value = "事後集会はすでに申込済です。"
                }else if(set_jigo[s].jokyo > 1){
                  jigo_message.value = "事後集会はすでに参加済です。"
                }
                set_jigo_id = set_jigo[s].jigo_id
              jigo_moushikomi_list.value[0] = set_jigo[s]

            }
          }
        }
      }
    }
  }else{
    
    // この体験プログラムに事後集会はありません。
    jigo_set_flg.value = 3
    jigo_message.value = "この体験プログラムに事後集会はありません。"
    
  }
}

// 指定した内容を確認する
let Set_jisseki = function(){

  // ボタンを押した時点で〆切日が過ぎていた場合は申込不可
  const check_today = new Date()
  let check_shubetsu = Shakyo_data.end_shubetsu
  let check_shimekiri = new Date()


  let moshikomi_ok = 0  // 申込不可なら1
                
  // 受付〆切日種別が2（プログラム単位）の場合はそちらを確認する
  if(check_shubetsu == 2){
    // プログラムに〆切日が設定されているはこちらをチェック
    if(taiken_list.shimekiri_date){
      let shimekiri = new Date(taiken_list.shimekiri_date)
      shimekiri = shimekiri.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      shimekiri = new Date(shimekiri);
      shimekiri.setHours(shimekiri.getHours()-9);
      check_shimekiri = shimekiri
      if(check_shimekiri < check_today){
        // 申込不可
        moshikomi_ok = 1
        message.value = "申込〆切日を過ぎました。このプログラムには申込みできません。";
        message_method.value = "moshikomi_end";
      }
    }else{
      // プログラムに〆切日が設定されていない場合は日数をチェック
      let set_date = moushikomi_start
      set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      set_date = new Date(set_date)
      set_date.setHours(0, 0, 0, 0);//0時0分0秒に設定

      let set_today = check_today
      set_today = set_today.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      set_today = new Date(set_today)
      set_today.setHours(0, 0, 0, 0);//0時0分0秒に設定
      // 申込日の初日から今日の日付を差し引いて日数を取得
      let checkDay = (set_date - set_today) / 86400000 ;
        
      // 今日と初日から算出した日数がプログラムに設定されている日数を下回る場合
      if (checkDay < taiken_list.shimekiri_nissu) {
        // 申込不可
        moshikomi_ok = 1
        message.value = "申込〆切日数（開催日の〇日前まで申込可能）を無視した日付を選択しています。別の日付を選択してください。";
        message_method.value = "return_detail";
      }
    }

  }else if(check_shubetsu == 1){
    // 受付〆切日種別が1（事業単位）なら事業単位の日付を入力
    if(Shakyo_data.end_date){
      let set_time = " 23:59:59"
      if(Shakyo_data.end_time) {
        set_time = Shakyo_data.end_time
      }
      let end_date = new Date(Shakyo_data.end_date + " "+set_time)
      end_date = end_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      end_date = new Date(end_date);
      end_date.setHours(end_date.getHours());
      check_shimekiri = end_date
      if(check_shimekiri < check_today){
        // 申込不可
        moshikomi_ok = 1
        message.value = "申込〆切日を過ぎました。このプログラムには申込めません。";
        message_method.value = "moshikomi_end";
      }
    }
  }

  if (moshikomi_ok == 1) {
    // ローディングアイコンストップ
    emit('call',{ cmd:'loading_end_noreload' })
    message_cat.value = 0;
    message_flag.value = true;
    contentMessage.value = MessageModal
    return
  }
  let taiken = []

  // 施設・地域活動の場合のみ選択した日付から申込日リストを作成する
  if(shubetsu == 1){
    for(let t = 0;t < sanka_list.length;t++){
      taiken[taiken.length] = {"kaisai_date":sanka_list[t].kaisai_date,
      "jikantai_start":sanka_list[t].jikantai_start,
      "jikantai_end":sanka_list[t].jikantai_end,
      "ninzu":sanka_list[t].ninzu,
      "teiin":sanka_list[t].teiin,
      "taiken_id":taiken_id}
    
    }
    for(let s = 0;s < sanka_list_sub.length;s++){
      let sub_moushikomi = sanka_list_sub[s]
      let sub_katsudou = sub_list[s]
      for(let t = 0;t<sub_moushikomi.length;t++){
        taiken[taiken.length] = {"kaisai_date":sub_moushikomi[t].kaisai_date,
        "jikantai_start":sub_moushikomi[t].jikantai_start,
        "jikantai_end":sub_moushikomi[t].jikantai_end,
        "ninzu":sub_moushikomi[t].ninzu,
        "teiin":sub_moushikomi[t].teiin,
        "taiken_id":sub_katsudou.taiken_id}
      
      }
    }
  }


  // 出力するエラーメッセージ
  let error_message = ""

  // セットする事前説明会
  let jizen = []

  // jizen_set_flgの内訳
  // 0：事前説明会を何も申込んでいない
  // 1：申込んだ事前説明会ではこの体験プログラムに申込めないので、改めて申込む
  // 2：申込んだ事前説明会でOKなので、改めて事前説明会を申込む必要はない
  // 3：事前説明会が必要のない体験プログラム
  if(jizen_set_flg.value != 2 && jizen_set_flg.value != 3){
    // 事前説明会が選択されているかチェック
    let jizen_elements = document.getElementsByName('jizen')
    let jizen_length = jizen_elements.length
    let check_value = null
    for(let i = 0;i < jizen_length;i++){
      if(jizen_elements.item(i).checked){
        // 選択されている場合はそのvalueを格納
        check_value = jizen_elements.item(i).value
      }
    }

    // 何もチェックされていない場合はエラー
    if(check_value == null){
      error_message += "事前説明会が選択されていません。\n"
    }else{

      jizen[0] = {"jizen_id":disp_jizen_list.value[check_value].jizen_id,"kaisai_date":disp_jizen_list.value[check_value].kensyu_date,"jikantai_start":disp_jizen_list.value[check_value].jikantai_start}

      if(disp_jizen_list.value[check_value].jikantai_end){
        jizen[0]["jikantai_end"] = disp_jizen_list.value[check_value].jikantai_end
      }
      
      set_jizen_id = jizen[0].jizen_id
    }
  }

  let jigo_no_set = 0 // 事後集会が任意のときは、申し込まなくていいので配列に入れない　 0は入れる、1は入れない
  // セットする事後集会
  let jigo = []
  // jigo_set_flgの内訳
  // 0：事後集会を何も申込んでいない
  // 1：申込んだ事後集会ではこの体験プログラムに申込めないので、改めて申込む
  // 2：申込んだ事後集会でOKなので、改めて事後集会を申込む必要はない
  // 3：事後集会が必要のない体験プログラム
  if(jigo_set_flg.value != 2 && jigo_set_flg.value != 3){
    // 事後集会が選択されているかチェック
    let jigo_elements = document.getElementsByName('jigo')
    let jigo_length = jigo_elements.length
    
    let check_value = null
    for(let i = 0;i < jigo_length;i++){
      if(jigo_elements.item(i).checked){
        // 選択されている場合はそのvalueを格納
        check_value = jigo_elements.item(i).value
      }
    }

    // 何もチェックされていない場合はエラー
    if(check_value == null){
      for(let j = 0;j<disp_jigo_list.value.length;j++){
        if(disp_jigo_list.value[j].syomei_flg == 1){
          jigo_no_set = 1
        }
      }
      // 任意のものがなければエラー
      if(jigo_no_set == 0) error_message += "事後集会が選択されていません。\n"
    }else{
      jigo[0] = {"jigo_id":disp_jigo_list.value[check_value].jigo_id,"kaisai_date":disp_jigo_list.value[check_value].kaisai_date,"jikantai_start":disp_jigo_list.value[check_value].jikantai_start}

      if(disp_jigo_list.value[check_value].jikantai_end){
        jigo[0]["jikantai_end"] = disp_jigo_list.value[check_value].jikantai_end
      }

      set_jigo_id = jigo[0].jigo_id
    }
  }


  // 何かしらエラーがあった場合は処理中断
  if(error_message != ""){
    message.value = error_message;
    message_cat.value = 0;
    message_flag.value = true;
    message_method.value = "error";
    contentMessage.value = MessageModal
    return
  }

  // 更新に利用する配列を作成する
  jisseki = {"taikenuser_id":user_id,"taiken_id":taiken_id,"taiken":taiken,"jizen_id":set_jizen_id,"jigo_id":set_jigo_id}

  // 事前説明会は必要な場合のみセット
  if(jizen_set_flg.value != 2 && jizen_set_flg.value != 3){
    jisseki["jizen"] = jizen
  }
  
  // 事後集会は必要な場合のみセット
  if(jigo_set_flg.value != 2 && jigo_set_flg.value != 3){
    // 事後集会を入れる必要があるならセット
    if(jigo_no_set == 0) jisseki["jigo"] = jigo
  }
  
  // 確認モードへ
  mode.value = 1

  // ページトップまでスクロール  
  emit('call',{cmd:'page_scroll'});

  /*
  message.value ="この内容で申込みますか？";
  message_cat.value = 1;
  message_flag.value = true;
  message_method.value = "jisseki_add";
  contentMessage.value = MessageModal
  */
      
}


// 確認画面から戻る
let Return_check = function(){
  mode.value = 0
  // ページトップまでスクロール  
  emit('call',{cmd:'page_scroll'});

}


// 申込内容を送る
let Send_jisseki = function(){

  // 内容に同意されていない場合は申込不可（制作・寄付のみ）
  if(naiyou_doui.value != true){
    
    message.value = "活動内容に同意しない場合は申込みできません。";
    message_cat.value = 0;
    message_flag.value = true;
    message_method.value = "error";
    contentMessage.value = MessageModal
    return
  }
  
            // 追加処理へ(事前説明会フラグ、キャンセルするID、ユーザーIDを追加)
            emit('call',{cmd:'toroku',
            jisseki:jisseki,
            cancel_wait_flg:cancel_wait_flg,
            cancel_jizen_id:cancel_jizen_id,
            jizen_set_flg:jizen_set_flg.value,
            taiken_name:taiken_list.name,
            user_id:user_id,
            user_name:GlobalData.user_name,
            message_title:message_title.value.replace(/^[\s　]+|[\s　]+$/g, ''),      // 前後のスペース(半角・全角)をはずす
            message_honbun:message_honbun.value.replace(/^[\s　]+|[\s　]+$/g, '') }); // 前後のスペース(半角・全角)をはずす
}

// 事前説明会をキャンセルする（キャンセルの必要がある場合の対応）
// jisseki：キャンセルの後に追加する実績データ
let cancel_jizen_error = 0
let Jizen_cancel = function(){

  let send_array = {
    user_id: user_id,
    program_id:cancel_jizen_id,
    program_kbn:2,
    jokyo:9,
    update_user:getUser_email()//更新者（＝ログインユーザーのメールアドレス）
  }
  axios.post(URL + "Jisseki_Programupdate",send_array,GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
  .then(response => {
    if(response.data["status"] == 1){
        alert("事前説明会の更新エラー\n"+response.data["message"])
    }else{
        // 追加処理へ
        emit('call',{cmd:'toroku',jisseki:jisseki});
    }
  })
  .catch(error => {  
        if(cancel_jizen_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "answer_error";
            contentMessage.value = MessageModal
        }else{
            cancel_jizen_error++
            setTimeout(function(){
              Jizen_cancel()
            },"1000")
        }
        
    })
}

// メッセージのデータを追加する
let message_add_error = 0
const message_add = () =>{
  axios.post(URL +"Message_add",
        {
          shakyo_name:Shakyo_data.choson_code,
          choson_code:Shakyo_data.choson_code,
          taikenuser_id:GlobalData.user_id,
          program_id:taiken_id,
          message_title:message_title.value,
          message_honbun:message_honbun.value,

        },
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
            if(response.data["status"] == 1){  // 異常終了時の処理
              message.value = "メッセージの送信に失敗しました。時間をおいてから再度お試しください。";
              message_method.value = "message_error";
              message_cat.value = 0;
              message_flag.value = true;
              contentMessage.value = MessageModal
                
            }else{// 正常終了時の処理

              // 履歴を追加
              rireki_add(8)
            }
        })
        .catch(error => {
            if(message_add_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "message_error";
                contentMessage.value = MessageModal
            }else{
                message_add_error++
                setTimeout(function(){
                  message_add()
                },"1000")
            }
      })
}

  // 履歴登録
  let rireki_add_error = 0
let rireki_add = function(kubun){
    const today = new Date()
    let set_date = new Date(today);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
    //rireki_kanri_add(set_date,2,GlobalData.user_id,1,program_id,0)
    let send_data = {shakyo_name:route.params.shakyo,
        choson_code:Shakyo_data.choson_code,
        taikenuser_id:GlobalData.user_id,
        program_kbn:1,
        program_id:taiken_id,
        kubun:kubun,
        toroku_date:set_date,
        update_user:GlobalData.$User_email}

        // APIへ値を送信する
        axios.post(URL+"Rireki_add",
        send_data,
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {

            if(response.data["status"] == 1){

                message.value = GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "rireki_add_error";
                contentMessage.value = MessageModal
            }
            
        })
        .catch(error => {
            if(rireki_add_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "rireki_add_error";
                contentMessage.value = MessageModal
            }else{
                rireki_add_error++
                setTimeout(function(){
                  rireki_add(kubun)
                },"1000")
            }
      })
}

    // メッセージを表示するウィンドウでOKを押された時
    let OK_message = function(){ 
        Close_message();//メッセージを表示するウィンドウを閉じる
     
        // message_methodの内容に応じてこちら（親コンポーネント）の関数を起動する
        if(message_method.value == "jisseki_add"){
          
            // 追加処理へ(事前説明会フラグ、キャンセルするID、ユーザーIDを追加)
            emit('call',{cmd:'toroku',
            jisseki:jisseki,
            cancel_jizen_id:cancel_jizen_id,
            jizen_set_flg:jizen_set_flg.value,
            user_id:user_id,
            message_title:message_title.value.replace(/^[\s　]+|[\s　]+$/g, ''),      // 前後のスペース(半角・全角)をはずす
            message_honbun:message_honbun.value.replace(/^[\s　]+|[\s　]+$/g, '') }); // 前後のスペース(半角・全角)をはずす
        }else if(message_method.value == "moshikomi_end"){
          // 申込〆切日を過ぎた場合
          home() // HOMEへ戻る
        }else if(message_method.value == "return_detail"){
          // 詳細画面へ戻す
          Return_detail()
        }
    }

    // メッセージを表示するウィンドウを閉じる
    let Close_message = function(){
        message_flag.value = false;
        contentMessage.value = null
    }

    // 体験開始日の体裁を整える
    let TaikenkaishiSetting = function(date){

      let taikenkaishi_date = new Date(date)
      taikenkaishi_date = new Date(taikenkaishi_date.getFullYear(),taikenkaishi_date.getMonth(),taikenkaishi_date.getDate(),23,59,59)

      return taikenkaishi_date
        
    }

    let manual_open = function(){
      let url = "https://zest-newsprint-e3e.notion.site/161c0be34f8f80fc87baf85432ed7220"
      window.open(url,"_blank")
  }

  // Q&Aを開く
  const qanda_open = () =>{

    let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
    window.open(url,"_blank")
  }        
      

/* 変数の監視 */
watchEffect(() => {

})

//------------------- Googlemap（外部リンク）へ
const jusho = (set_jusho) => { window.open("http://local.google.co.jp/maps?q="+set_jusho,"_blank") }

const home = () => { router.push('/'+cityname+'/Taiken') }
const ichiran = () => {
    router.push('/'+cityname+'/Taiken/Program')
}

/* 初期処理 */

//---------------- 社協英名から社協ごとのデータを取得
        axios.post(URL+"Shakyo_read", 
            {shakyo:route.params.shakyo}
            ).then(response => {
            Shakyo_data =  response["data"]
            
            // キャンセル待ち機能を利用する場合、キャンセル待ちの実績が存在するかチェックする
            if(Shakyo_data.cancel_setting == 0){
              if(sanka_list.length != 0){
                  for(let s = 0;s<sanka_list.length ;s++){
                    if(sanka_list[s].ninzu >= sanka_list[s].teiin){
                      cancel_wait_flg = 1
                    }
                  }
                }

              if(props.param.sanka_sub){
                sanka_list_sub = props.param.sanka_sub
                console.log(sanka_list_sub)
                for(let s = 0;s<sanka_list_sub.length;s++){
                  let sub = sanka_list_sub[s]
                  sub_cancel_wait_message.value[s] = ""
                  console.log(sub)
                for(let m = 0;m<sub.length;m++){
                    if(sub[m].ninzu >= sub[m].teiin){
                    cancel_wait_flg = 1
                    }
                  }
                }
              }
            }
            
            // 実施するなら事前説明会を確認、表示
            if(Shakyo_data.jizen_jisshi == 1){
              Set_jizen_list()
            }else{
              // 実施しないなら事前説明会が存在しないものとしてフラグを立てる
              jizen_set_flg.value = 3
            }

            
            // 実施するなら事後集会を確認、表示
            if(Shakyo_data.jigo_jisshi == 1){
              Set_jigo_list()
            }else{
              // 実施しないなら事後集会が存在しないものとしてフラグを立てる
              jigo_set_flg.value = 3

            }
            console.log(jizen_set_flg.value)
            console.log(jigo_set_flg.value)

        })
        .catch(error => {
            
        })
</script>

<style scoped>

input[type=radio]{
  width: 20px;
  height: 20px;
}

.jyokyo_nittei{
  border: 1px solid #000;
    display: flex;
    align-items: center;
}

.other_area{
  text-align: left;padding: 5px;
}

.message_button{
    height: 40px;
    width:95%;
    max-width: 200px;
    text-align: center;
    padding: 10px;
    background-color: red;
    color: white;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
.message_button:hover{
  background-color: red;
  color: white;
}
@media screen and (min-width: 961px) {

  .floating_over{
      display: none
  }

  .pc_only{
    display:revert
  }
  .sp_only{
    display:none
  }
}
@media screen and (max-width: 960px) {

  /* スマホの場合は項目名を大きめにする */
  label{
    font-size: 19px;
  }
  .floating_over{
    color:white;
      display: flex;
        
      flex-direction: column;
      align-items: center;
  }

  #moushikomi_table{
    width:100%;
  }
  
  .pc_only{
    display:none
  }
  .sp_only{
    display:revert
  }
}

</style>